import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Countdown = ({ onFinish, prepMode = false, minDelay, maxDelay }) => {
    const [message] = useState("STANDBY...");

    useEffect(() => {
        let timer;
        // Normal: 1.5s to 4s | Prep: 5s to 8s (overridable via minDelay/maxDelay)
        const lo  = minDelay ?? (prepMode ? 5000 : 1500);
        const hi  = maxDelay ?? (prepMode ? 8000 : 4000);
        const delay = lo + Math.random() * (hi - lo);

        timer = setTimeout(() => {
            onFinish();
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [onFinish, prepMode]);

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.4)',
            zIndex: 100,
            pointerEvents: 'none'
        }}>
            <div style={{
                fontSize: '60px',
                fontWeight: '900',
                color: '#fff',
                letterSpacing: '5px',
                textShadow: '0 0 20px rgba(0,0,0,0.5)',
                animation: 'pulse 1.5s ease-in-out infinite'
            }}>
                {message}
            </div>
            <style>{`
                @keyframes pulse {
                    0% { transform: scale(0.95); opacity: 0.7; }
                    50% { transform: scale(1.05); opacity: 1; }
                    100% { transform: scale(0.95); opacity: 0.7; }
                }
            `}</style>
        </div>
    );
};

Countdown.propTypes = {
    onFinish: PropTypes.func.isRequired,
    prepMode: PropTypes.bool,
    minDelay: PropTypes.number,
    maxDelay: PropTypes.number,
};

export default Countdown;
